export interface BusinessMenuItem {
  name: string;
  href: string;
  description?: string;
  icon: string;
}

export const businessMenuItems = [
  {
    name: "Limited Liability Company (LLC) Formation",
    href: "/form-an-llc.html",
    description: "Flexible structure that protects personal assets.",
    icon: "/assets/public/mega-menu/mega-menu-llc-icon.svg",
  },
  {
    name: "S Corporation Formation",
    href: "/s-corp-election.html",
    description: "Pass-through taxation with shareholder limits.",
    icon: "/assets/public/mega-menu/mega-menu-s-corp-icon.svg",
  },
  {
    name: "C Corporation Formation",
    href: "/form-a-corporation.html",
    description: "Investor-ready, scalable, formal structure.",
    icon: "/assets/public/mega-menu/mega-menu-c-corp-icon.svg",
  },
  {
    name: "Nonprofit Organization",
    href: "/form-a-nonprofit.html",
    description: "Mission-driven with potential tax exemptions.",
    icon: "/assets/public/mega-menu/mega-menu-non-prof-icon.svg",
  },
  {
    name: "Professional Corporation (PC)",
    href: "/professional-corporation-formation.html",
    description: "Corporation for licensed professionals.",
    icon: "/assets/public/mega-menu/mega-menu-pc-icon.svg",
  },
  {
    name: "Partnership Registration",
    href: "/partnership-registration.html",
    description: "Simple setup for two or more owners.",
    icon: "/assets/public/mega-menu/mega-menu-partnership-icon.svg",
  },
  {
    name: "Sole Proprietorship Setup",
    href: "/sole-proprietorship-setup.html",
    description: "Fastest way to start solo.",
    icon: "/assets/public/mega-menu/mega-menu-sole-prop-icon.svg",
  },
];

export const manageMenuItems = [
  {
    name: "Annual Report Filing",
    href: "/annual-report.html",
    description: "File your yearly report to keep business active.",
    icon: "/assets/public/mega-menu/mega-menu-ar-icon.svg",
  },
  {
    name: "Registered Agent Service",
    href: "/registered-agent.html",
    description: "Protect your privacy and receive state notices.",
    icon: "/assets/public/mega-menu/mega-menu-ra-icon.svg",
  },
  {
    name: "Reinstate Your Company",
    href: "/file-reinstatement.html",
    description: "Get your business operational again.",
    icon: "/assets/public/mega-menu/mega-menu-reinstate-icon.svg",
  },
  {
    name: "Update Business Information",
    href: "/address-change.html",
    description: "Change your business details.",
    icon: "/assets/public/mega-menu/mega-menu-amendment-icon.svg",
  },
  {
    name: "Close a Business (Dissolution)",
    href: "/file-dissolution.html",
    description: "Officially shut down your company with the state.",
    icon: "/assets/public/mega-menu/mega-menu-dissolve-icon.svg",
  },
  {
    name: "Withdraw from a State",
    href: "/foreign-withdrawal.html",
    description: "End your registration where you no longer operate.",
    icon: "/assets/public/mega-menu/mega-menu-withdraw-icon.svg",
  },
  {
    name: "Fictitious Name Registration (DBA)",
    href: "/file-foreign-qualification.html",
    description: "Register a DBA name for your business.",
    icon: "/assets/public/mega-menu/mega-menu-dba-icon.svg",
  },
];

export const additionalManageItems = [
  {
    name: "Annual Report Amendment",
    href: "/file-amendment.html",
  },
  {
    name: "Initial Report (if required)",
    href: "/contact.html",
  },
  {
    name: "Beneficial Ownership Information (BOI) Report",
    href: "/boi-reporting.html",
  },
  {
    name: "Get Employer Tax ID (EIN)",
    href: "/get-an-ein.html",
  },
  {
    name: "Certificate of Status",
    href: "/file-certificate-of-status.html",
  },
  {
    name: "Certified Copies",
    href: "/contact.html",
  },
  {
    name: "Resignation of Registered Agent",
    href: "/dashboard/filings/update_registered_agent",
  },
  {
    name: "Licenses & Renewals (state level)",
    href: "/contact.html",
  },
  {
    name: "Mergers",
    href: "/contact.html",
  },
  {
    name: "Virtual Address Assignement",
    href: "/contact.html",
  },
];

export const resourcesMenuItems = [
  {
    name: "How to Start a Business",
    href: "/new-business-guide.html",
    icon: "/assets/public/mega-menu/mega-menu-llc-icon.svg",
  },
  {
    name: "FAQ & Quick Answers",
    href: "/faq",
    icon: "/assets/public/mega-menu/mega-menu-llc-icon.svg",
  },
];
